import { render } from "./Home.vue?vue&type=template&id=652b7ff3&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=652b7ff3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-652b7ff3"

export default script